<template>
<div class="uk-margin-top uk-margin-large-bottom">
  <div class="uk-card uk-card-default uk-card-small uk-border-rounded uk-margin-bottom">
    <div class="uk-card-body">
      <div class="uk-grid uk-child-width-1-1" data-uk-grid>
        <div>
          <div class="uk-margin">
            <label>
              <input class="uk-checkbox" type="checkbox" v-model="config.multilanguage.enable"> Mehrsprachkeit aktivieren
            </label>
          </div>
          <div class="uk-margin" v-if="config.multilanguage.enable">
            <label class="uk-form-label">Sprachen</label>
              <v-select
                :options="[{label: 'Deutsch', value: 'de'}, {label: 'Englisch', value: 'en'}, {label: 'Französisch', value: 'fr'}, {label: 'Italienisch', 'value': 'it'}, {label: 'Spanisch', value: 'es'}]"
                multiple
                v-model="config.multilanguage.languages"
              ></v-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="uk-grid" data-uk-grid>
    <div class="uk-width-1-1">
      <div class="uk-flex uk-flex-right">
        <button
          class="uk-button uk-button-primary"
          @click.prevent="store"
          :disabled="submitting"
        >Speichern</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import PageService from "@/services/page.service";
import vSelect from "vue-select";
export default {
  data() {
    return {
      config: {
        multilanguage: false
      },
      submitting: false
    };
  },
  components: {
    vSelect
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    ...mapActions({
       getLanguages: 'pages/getLanguages',
    }),
    async getConfig() {
      let response = await PageService.getConfig();
      this.config = response.data;
    },
    async store() {
      this.submitting = true;
      let response = await PageService.storeConfig(this.config);

      this.getConfig();
      this.submitting = false;
      this.getLanguages()
      iziToast.success({
        position: "topRight",
        title: "OK",
        message: "Daten gespeichert!"
      });
    }
  }
}
</script>
